import * as React from 'react';
import { useState, useCallback } from 'react';
import { connect } from 'react-redux';
import styled, { css } from 'styled-components';
import { color } from '@core-ds/primitives';
import AccordionItem from './accordion_item';
import AccordionSubitem from './accordion_subitem';
import LanguageButton from '../dropdowns/language_button';
import LanguageDropdown from '../dropdowns/language_dropdown';
import StoreFlag from '../headings/store/store_flag';
import StoreDropdown from '../headings/store/store_dropdown';
import { useMediaQuery } from 'react-responsive';

const Container = styled.div<{ isOpen?: boolean }>`
   position: absolute;
   padding: 0 16px;
   margin-top: 60px;
   top: 0;
   left: 0;
   right: 0;
   height: calc(100vh - 60px);
   background: ${color.gray[900]};
   opacity: 0;
   visibility: hidden;
   transform: translateX(-100%);
   transition: all 0.25s;
   overflow-y: scroll;
   -webkit-overflow-scrolling: touch;
   z-index: 200;

   ${props =>
      props.isOpen &&
      css`
         opacity: 1;
         visibility: visible;
         transform: translateX(0);
      `};
`;

const mapStateToProps = state => ({
   headerState: state.headerState,
});

const regionAccordionTitle = _js('Language / Region');

const MobileMenu = ({ headerState, links, languageDropdown, stores }) => {
   const { displayMobileMenu } = headerState;

   const [activeId, setActiveId] = useState(links[0].title);

   const accordionItemClicked = useCallback(
      clickedId => {
         setActiveId(activeId === clickedId ? null : clickedId);
      },
      [activeId, setActiveId]
   );

   const { languages, translationPreferencesUrl, machineTranslationRequested } = languageDropdown;

   const selectedLanguage = languages.find(language => language.isSelected);
   const currentStore = stores.find(store => store.isDisplayStore);

   const fullWidthDropdown = useMediaQuery({ maxWidth: '450px' });

   return (
      <Container id="mobileMenuContainer" isOpen={displayMobileMenu}>
         {links.map(
            data =>
               data.disabled || (
                  <AccordionItem
                     key={`accordion-item-${data.title}`}
                     title={data.title}
                     isActive={data.title === activeId}
                     onClick={accordionItemClicked}
                  >
                     {data.sublinks.map(
                        (sublink, index) =>
                           sublink.disabled || (
                              <AccordionSubitem
                                 href={sublink.url}
                                 key={`accordion-${data.title}-sublink-${index}`}
                                 title={sublink.title}
                              />
                           )
                     )}
                  </AccordionItem>
               )
         )}
         <AccordionItem
            title={regionAccordionTitle}
            isActive={regionAccordionTitle === activeId}
            onClick={accordionItemClicked}
         >
            <AccordionSubitem
               title={selectedLanguage.autoglottonym}
               icon={<LanguageButton isoCode={selectedLanguage.isoCode} />}
               fullWidthDropdown={fullWidthDropdown}
               dropdown={
                  <LanguageDropdown
                     translationPreferencesUrl={translationPreferencesUrl}
                     machineTranslationEnabled
                     machineTranslationRequested={machineTranslationRequested}
                     languages={languages}
                     isLightTheme
                     mobile={fullWidthDropdown}
                  />
               }
            />
            <AccordionSubitem
               title={currentStore.name}
               icon={<StoreFlag storeCode={currentStore.storeCode} />}
               fullWidthDropdown={fullWidthDropdown}
               dropdown={
                  <StoreDropdown
                     stores={stores}
                     currentStore={currentStore}
                     mobile={fullWidthDropdown}
                  />
               }
            />
         </AccordionItem>
      </Container>
   );
};

export default connect(mapStateToProps)(MobileMenu);
